import {useEffect} from 'react';

const useEventListener = <E extends Event = Event>(type: string, listener: (event: E) => void) => {
    useEffect(() => {
        document.addEventListener(type, listener as EventListener);

        return () => document.removeEventListener(type, listener as EventListener);
    }, []);
};

export default useEventListener;
